module.exports = {
  inPartnership: 'In partnership with Holiday Extras',
  discountApplied: 'Your discount code has been applied',
  cashbackApplied: 'Your cashback code has been applied',
  emailDiscountApplied: 'Your email discount has been applied'
}
